import React, { useRef } from 'react';
import { formatarTempo } from '../../helpers/FormatHelpers';
import { buscarCorSLA } from '../../rules/regraSLA';

const CardTriagemDetalhe = ({ dataPacientes, tipoSelecionado, ps_tipo }) => {

  const isInfantil = ps_tipo === 'infantil';
  const isPediatria = (item) => item.DESCRICAOITEM.includes("INFANTIL");

  const pacientesAdulto = dataPacientes.filter((item) => !isPediatria(item));
  const pacientesInfantil = dataPacientes.filter((item) => isPediatria(item));

  const title = isInfantil ? 'PS Infantil' : 'PS Adulto';
  const pacientes = isInfantil ? pacientesInfantil : pacientesAdulto;
  const total = pacientes.length;

  return (
    <>
      <div className='card-pacientes card-triagem-detalhe'>
        <div className='card-grupo'>
          <div className='card-title'>{title}</div>
          <div className='card-title'>{total}</div>
        </div>
        <div className='card-header'>
          <table>
            <thead>
              <tr>
                <th></th>
                <th>Totem</th>
								<th>Situação</th>
                <th className='col-senha'>Senha</th>
                <th className='col-espera' style={{ textAlign: 'right'}}>Espera</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {pacientes.map((paciente, index) => {
                const totem = paciente.DESCRICAOITEM.split(' - ')[0] ?? '';
                const senha = paciente.DESCRICAOITEM.split(' - ')[1] ?? '';
                const espera = paciente.VALOR ?? 0;
                const corSLA = buscarCorSLA({ tipoCard: tipoSelecionado, tempo: espera, tipoPaciente: ps_tipo });

                return (
                  <tr key={index}>
                    <td></td>
                    <td>{totem}</td>
										<td>{paciente.SITUACAO}</td>
                    <td className='col-senha'>{senha}</td>
                    <td className='col-espera' style={{ textAlign: 'right'}}>
                      <span className={"sla-dot " + corSLA}></span>
                      <span style={{marginLeft:'10px'}}>{formatarTempo(espera)}</span>
                    </td>
                    <td></td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default CardTriagemDetalhe;